import { FaChevronDown, FaChevronUp } from "react-icons/fa";

export default function RenderCreditCardDropDown({ handleCardSelect, showDropdown, cardDataToShow, cards, dropdownRef, handleCardClick }) {
  return (
    <div
      ref={dropdownRef}
      className="md:flex w-full items-center justify-between bg-[#F7F7F7] p-2.5 rounded-[10px] hidden gap-2 relative cursor-pointer"
      onClick={handleCardClick}
    >
      <div className="flex gap-2.5 items-center">
        <img
          src={cardDataToShow?.sub_variant?.logo || cardDataToShow?.sub_variant?.payment_network?.logo}
          alt={cardDataToShow?.sub_variant?.name}
          className="w-6 h-6 object-contain"
          loading="lazy"
        />
        <div className="font-Inter text-[10px] lg:text-sm font-medium">
          {cardDataToShow?.sub_variant?.bank?.display_name !== "*" && `${cardDataToShow?.sub_variant?.bank?.display_name} `}
          {cardDataToShow?.sub_variant?.name !== "*" && `${cardDataToShow?.sub_variant?.name} `}
          {cardDataToShow?.sub_variant?.payment_network?.name !== "*" && `${cardDataToShow?.sub_variant?.payment_network?.name} `}
          {cardDataToShow?.sub_variant?.variant?.name !== "*" && cardDataToShow?.sub_variant?.variant?.name}
        </div>
      </div>

      {showDropdown ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}

      {showDropdown && (
        <div className="absolute w-full max-h-[110px] overflow-y-auto top-full left-0 mt-2 bg-white border rounded-md shadow-lg z-10">
          {cards.map((card) => (
            <div
              key={card.id}
              className="p-2 text-sm cursor-pointer hover:bg-gray-200"
              onClick={() => handleCardSelect(card)}
            >
              {card?.sub_variant?.bank?.display_name !== "*" && `${card?.sub_variant?.bank?.display_name} `}
              {card?.sub_variant?.name !== "*" && `${card?.sub_variant?.name} `}
              {card?.sub_variant?.payment_network?.name !== "*" && `${card?.sub_variant?.payment_network?.name} `}
              {card?.sub_variant?.variant?.name !== "*" && card?.sub_variant?.variant?.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};